var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "padding-top": "50px" },
              attrs: { dense: "", extended: "", color: "primary", dark: "" },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "display-1",
                      attrs: { slot: "extension" },
                      slot: "extension",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-bottom": "10px" },
                          attrs: { "x-large": "" },
                        },
                        [_vm._v("assignment")]
                      ),
                      _vm._v("\n          Job Run Detail\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        flat: "",
                        dark: "",
                        to: { name: "ingestionDashboard" },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("arrow_back"),
                      ]),
                      _vm._v("Back to Dashboard"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _vm.job
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _vm._v(
                        "\n        Job " +
                          _vm._s(_vm.shorten(_vm.job.Id)) +
                          "\n        "
                      ),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: _vm.statusColor(_vm.job.Status),
                            dark: "",
                          },
                        },
                        [_vm._v(_vm._s(_vm.job.Status))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs6: "", sm4: "" } }, [
                            _c("strong", [_vm._v("Job ID:")]),
                            _vm._v(" " + _vm._s(_vm.job.Id)),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", sm4: "" } }, [
                            _c("strong", [_vm._v("Config ID:")]),
                            _vm._v(
                              " " + _vm._s(_vm.job.ConfigurationId || "-")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", sm4: "" } }, [
                            _c("strong", [_vm._v("Schedule:")]),
                            _vm._v(
                              " " + _vm._s(_vm.job.ScheduleName || "Manual")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", sm4: "" } }, [
                            _c("strong", [_vm._v("Started:")]),
                            _vm._v(
                              " " + _vm._s(_vm.formatDate(_vm.job.StartedAt))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", sm4: "" } }, [
                            _c("strong", [_vm._v("Completed:")]),
                            _vm._v(
                              " " + _vm._s(_vm.formatDate(_vm.job.CompletedAt))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", sm4: "" } }, [
                            _c("strong", [_vm._v("Duration:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatDuration(_vm.job.DurationSeconds)
                                )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-3" }),
                      _vm._v(" "),
                      _vm.job.ErrorMessage
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    color: "error",
                                    icon: "warning",
                                    value: true,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.job.ErrorMessage))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.job.SummaryLog
                        ? _c(
                            "div",
                            [
                              _c("v-subheader", [_vm._v("Summary Log")]),
                              _vm._v(" "),
                              _c("pre", { staticClass: "summary-json" }, [
                                _vm._v(
                                  _vm._s(_vm.formatJson(_vm.job.SummaryLog))
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("v-subheader", [_vm._v("Detail Log Entries")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-select", {
                    staticStyle: { "max-width": "150px" },
                    attrs: {
                      label: "Level",
                      items: _vm.logLevels,
                      clearable: "",
                    },
                    on: { change: _vm.loadEntries },
                    model: {
                      value: _vm.logFilter.level,
                      callback: function ($$v) {
                        _vm.$set(_vm.logFilter, "level", $$v)
                      },
                      expression: "logFilter.level",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.logEntries.length === 0 && !_vm.entriesLoading
                    ? _c(
                        "div",
                        { staticClass: "text-xs-center grey--text pa-3" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.entriesError
                                  ? "Detailed logs unavailable (Elasticsearch may be offline)."
                                  : "No log entries found."
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _c(
                        "v-timeline",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.logEntries, function (entry, i) {
                          return _c(
                            "v-timeline-item",
                            {
                              key: i,
                              attrs: {
                                color: _vm.entryLevelColor(entry.Level),
                                small: "",
                              },
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "elevation-1" },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "caption pa-2" },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            color: _vm.entryLevelColor(
                                              entry.Level
                                            ),
                                            small: "",
                                            dark: "",
                                          },
                                        },
                                        [_vm._v(_vm._s(entry.Level))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "grey--text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(entry.Timestamp)
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      entry.Source
                                        ? _c(
                                            "span",
                                            { staticClass: "ml-2 grey--text" },
                                            [
                                              _vm._v(
                                                "[" + _vm._s(entry.Source) + "]"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "py-1 px-2 body-2" },
                                    [_vm._v(_vm._s(entry.Message))]
                                  ),
                                  _vm._v(" "),
                                  entry.Exception
                                    ? _c(
                                        "v-card-text",
                                        { staticClass: "py-1 px-2" },
                                        [
                                          _c(
                                            "pre",
                                            { staticClass: "error-text" },
                                            [_vm._v(_vm._s(entry.Exception))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                  _vm._v(" "),
                  _vm.logEntriesTotalCount > _vm.logFilter.pageSize
                    ? _c("v-pagination", {
                        staticClass: "mt-2",
                        attrs: {
                          length: Math.ceil(
                            _vm.logEntriesTotalCount / _vm.logFilter.pageSize
                          ),
                        },
                        on: { input: _vm.loadEntries },
                        model: {
                          value: _vm.logFilter.page,
                          callback: function ($$v) {
                            _vm.$set(_vm.logFilter, "page", $$v)
                          },
                          expression: "logFilter.page",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }